<template>
<!-- 公用组件：专题讲座申报-新增-添加学员-->
  <div class="dept">
    <el-input
      class="search-dept"
      prefix-icon="el-icon-search"
      v-model.trim="deptName"
      @change="searchDep"
      size="small"
      placeholder="部门名称"
    />
    <el-tree
      lazy
      class="dept-tree"
      :data="treeData"
      :props="props"
      show-checkbox
      check-strictly
      highlight-current
      :expand-on-click-node="false"
      check-on-click-node
      node-key="uuid"
      @check="handleCheck"
      ref="deptTree"
      :load="loadNode"
    >
    </el-tree>
  </div>
</template>

<script>
import { deptTreeForClass } from "@/api/dept";
export default {
  props: {
  },
  data() {
    return {
      props: {
        label: "deptName",
        children: "zones",
        isLeaf: function(data, node) {
          return !data.hasChildren
        }
      },
      deptName: "",
      treeData: [],
    };
  },
  updated() {
    let doms = document.getElementsByClassName("el-tree-node__label");
    for (let i = 0; i < doms.length; i++) {
      const dom = doms[i];
      dom.title = dom.innerText;
    }
  },
  methods: {
    // 加载节点
    loadNode(node, resolve) {
      let params = {
        parentId: node.data && node.data.uuid || "",
        bNotAcrossDept: 1
      }
      deptTreeForClass(params).then(({ code, data }) => {
        if (code !== 0) return;
        let treeData = this.dealSourceData(data);
        resolve(treeData);
      });
    },
    // 搜索
    searchDep() {
      this.treeData = [];
      let params = {
        deptName: this.deptName,
        bNotAcrossDept: 1
      }
      deptTreeForClass(params).then(({ code, data }) => {
        if (code !== 0) return;
        this.treeData = this.dealSourceData(data);
      });
    },
    dealSourceData(arr) {
      if (!Array.isArray(arr)) return;
      return arr.map((x, i) => {
        return {
          ...x,
          // disabled: x.hasChildren,
        };
      });
    },
    // tree单选
    handleCheck(data) {
      this.$refs["deptTree"].setCheckedKeys([data.uuid]);
      const checkedNodes = this.$refs["deptTree"].getCheckedNodes();
      this.$emit("deptSelected", checkedNodes[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.dept {
  .search-dept {
    font-size: 12px;
    margin-bottom: 16px;
  }
  /deep/ .el-input__inner::placeholder {
    font-size: 12px;
  }
  .tree-dept {
    margin-top: 10px;
    background-color: #f4f8fb;
    color: #51627d;
    font-size: 12px;
    max-height: 540px;
    overflow: auto;
  }
}
/deep/ .el-tree-node__content {
  height: auto;
}
.checkbox_style {
  margin-top: 12px;
  margin-left: 6px;
}
</style>
